import React, { useState, Suspense } from "react";
import MainLayout from "../../components/buttonUi/MainLayout";
import { loadingComponent } from "../../modules/Maps/Map/utils";
import useDashboardHook from "../../hooks/dashboard/useDashboardHook";
import { getLocalStorage } from "../../helpers/localStorage";
import { Map, Video } from "lucide-react";
import { DashcamPageContent } from "src/pages/dashcam/DashcamPage";

const GoogleMaps = React.lazy(() =>
  import("../../modules/TrackingControls/TrackingControls")
);

const DEFAULT_V2_CLIENT_NAME = "CLAUDE MBIA";

const TrackingPageV2 = () => {
  const [primaryChecked, setPrimaryChecked] = useState(false);
  const [analyticsPeriod, setAnalyticsPeriod] = useState(null);
  const [viewMode, setViewMode] = useState("map");

  const { useValidateClientName } = useDashboardHook();
  const rawClientName = (getLocalStorage("username") || "").trim() || DEFAULT_V2_CLIENT_NAME;
  const { validationError } = useValidateClientName(rawClientName);

  const tabs = [
    {
      id: "map",
      label: "Map Mode",
      icon: Map,
    },
    {
      id: "video",
      label: "Video Mode",
      icon: Video,
    },
  ];

  if (validationError) {
    // onToastError(validationError);
  }

  return (
    <MainLayout>
      <div className="flex h-full min-h-0 w-full flex-col bg-[#f8fafc]" style={{zoom:0.8}}>
        <div className="border-b border-[#dbe4ee] bg-white px-4 pt-1">
          <div className="flex items-center gap-1">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = viewMode === tab.id;

              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setViewMode(tab.id)}
                  className={`inline-flex items-center gap-2 border-b-2 px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? "border-[#1693ff] text-[#1693ff]"
                      : "border-transparent text-[#4b5563] hover:text-[#1693ff]"
                  }`}
                >
                  <Icon size={16} />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="min-h-0 flex-1">
          {viewMode === "map" ? (
            <div className="flex h-full">
              <Suspense fallback={loadingComponent}>
                <GoogleMaps
                  primaryChecked={primaryChecked}
                  isAst={true}
                  useDevicesV2={true}
                  vehicleListDesign="groups-panel"
                  disableOverlay={true}
                  splitLayout="compact-v2"
                  analyticsPeriod={analyticsPeriod}
                  alertsList={<div />}
                  periodSelector={<div />}
                />
              </Suspense>
            </div>
          ) : (
            <DashcamPageContent />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default TrackingPageV2;
